// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-delete {
  margin-right: 1em;
}

.circle {
  margin-right: 1em;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxpc3QtY29sLWV0bC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGlCQUFBO0FBQ0o7O0FBQ0E7RUFDSSxpQkFBQTtBQUVKIiwiZmlsZSI6Imxpc3QtY29sLWV0bC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5idXR0b24tZGVsZXRlIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDFlbTtcbn1cbi5jaXJjbGUge1xuICAgIG1hcmdpbi1yaWdodDogMWVtO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/etl-v1/etl-update/etl-update-filter/list-col-etl/list-col-etl.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;AACA,oZAAoZ","sourcesContent":[".button-delete {\n    margin-right: 1em;\n}\n.circle {\n    margin-right: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
